import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { useIntl } from 'react-intl'
import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyTierThresholds from 'loyalty/selectors/getLoyaltyTierThresholds'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import LoyaltyTierRequirementCards from './LoyaltyTierRequirementCards'
import Sheet from 'components/utils/Sheet'
import type { ComponentProps } from 'react'

interface Props {
  background?: ComponentProps<typeof Sheet>['background']
}

function LoyaltyLandingPageMovingTiersSection({ background }: Props) {
  const intl = useIntl()
  const tierThresholds = useAppSelector(getLoyaltyTierThresholds)
  const [currentTier] = useCurrentLoyaltyTier()

  if (!tierThresholds) return null

  const headingText = intl.formatMessage({
    id: '1GCNHgpOGPf-3nICDc84',
    defaultMessage: 'Moving up through the tiers',
    description: 'Section heading for the loyalty tier progression section',
  })
  const bodyText = intl.formatMessage({
    defaultMessage: 'To progress from Bronze to Silver, Gold and Platinum you’ll need to earn a certain number of Status Credits and count up your Nights within a calendar year.',
    id: 'CmpiXvUVwdx0GoNzx8aC',
    description: 'Description explaining how to progress through loyalty tiers',
  })

  return <Sheet
    paletteType="default"
    padding="24 0 0 0"
    tabletPadding="48 0 0 0"
    background={background ?? 'light-background'}
  >
    <LayoutContainer variant="medium">
      <VerticalSpacer gap={24}>
        <VerticalSpacer gap={8}>
          <Heading variant="heading2" align="center">
            {headingText}
          </Heading>
          <BodyText variant="medium" align="center">
            {bodyText}
          </BodyText>
        </VerticalSpacer>
        <LoyaltyTierRequirementCards currentTier={currentTier} />
      </VerticalSpacer>
    </LayoutContainer>
  </Sheet>
}

export default LoyaltyLandingPageMovingTiersSection
